// extracted by mini-css-extract-plugin
module.exports = {"root":"f-virtual-list__1WaM6for"};